import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./calendar.svg?react";

export const CalendarIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
